/* eslint-disable react/prop-types */
import React from 'react';
import _ from 'lodash';
import { Formik, Form } from 'formik';

import { CONSTANT } from '../utils/constant';
import RegistrationModal from './modal';

import {
  FirstName,
  LastName,
  Email,
  Password,
  Province,
  Contact,
  Role,
  Channel,
  MultiChannel,
  Outlet,
  Cpms,
  Dealership,
  SalesManager,
  SalesManagerEmail,
  Captcha,
  Button,
  MultiProvince,
  ChannelOrgCode,
  Xid,
  StoreCode
} from './fields';

const {
  KEYS: {
    CHANNELS: { DEALER, BCX_CARE, ADT, HEALTH, CSD, NBD, CORP_STORE }
  }
} = CONSTANT;

const RegistrationForm = ({
  labels,
  schema,
  onSubmit,
  initialValues,
  loading,
  onChange,
  showModal,
  confirmationDialog,
  isRedirectedFromPassport
}) => {
  const getFields = (role, value) => {
    const valueChannel =
      +role === 11
        ? _.get(value, 'multiChannels', [])
        : _.get(value, 'channel.0.id', '');

    if (valueChannel === DEALER)
      return [
        Province,
        Channel,
        Dealership,
        ChannelOrgCode,
        Cpms,
        Outlet,
        SalesManager,
        SalesManagerEmail
      ];

    if (valueChannel === CORP_STORE)
      return [
        Province,
        Channel,
        StoreCode,
        Xid,
        SalesManager,
        SalesManagerEmail
      ];

    if (
      [2, 7].includes(+role) &&
      [BCX_CARE, ADT, HEALTH, CSD, NBD].includes(valueChannel)
    )
      return [Province, Channel, Xid, SalesManager, SalesManagerEmail];

    if (+role === 11) {
      if (valueChannel.includes(DEALER) && !valueChannel.includes(CORP_STORE))
        return [
          MultiProvince,
          MultiChannel,
          Dealership,
          ChannelOrgCode,
          Xid,
          SalesManager,
          SalesManagerEmail
        ];
      if (valueChannel.includes(CORP_STORE) && !valueChannel.includes(DEALER))
        return [
          MultiProvince,
          MultiChannel,
          StoreCode,
          Xid,
          SalesManager,
          SalesManagerEmail
        ];
      if (valueChannel.includes(CORP_STORE) && valueChannel.includes(DEALER))
        return [
          MultiProvince,
          MultiChannel,
          Dealership,
          ChannelOrgCode,
          StoreCode,
          Xid,
          SalesManager,
          SalesManagerEmail
        ];
      return [
        MultiProvince,
        MultiChannel,
        Xid,
        SalesManager,
        SalesManagerEmail
      ];
    }

    return [Province, Channel, Cpms, Outlet, SalesManager, SalesManagerEmail];
  };

  return (
    <>
      {showModal && <RegistrationModal show labels={confirmationDialog} />}
      <Formik
        initialValues={initialValues}
        validationSchema={schema}
        onSubmit={(values, actions) => {
          onSubmit(values, actions);
        }}
      >
        {({ errors, touched, setFieldValue, values }) => (
          <Form>
            <Role labels={labels} errors={errors} touched={touched} />
            <FirstName
              labels={labels}
              errors={errors}
              touched={touched}
              disabled={isRedirectedFromPassport}
            />
            <LastName
              labels={labels}
              errors={errors}
              touched={touched}
              disabled={isRedirectedFromPassport}
            />
            <Email
              labels={labels}
              errors={errors}
              touched={touched}
              disabled={isRedirectedFromPassport}
            />
            <Password labels={labels} errors={errors} touched={touched} />
            <Contact labels={labels} errors={errors} touched={touched} />

            {values.role && (
              <>
                {getFields(values.role, values).map(Component => (
                  <Component
                    labels={labels}
                    errors={errors}
                    touched={touched}
                    role={values.role}
                    values={values}
                    setFieldValue={setFieldValue}
                  />
                ))}
              </>
            )}

            <Captcha onChange={onChange} errors={errors} touched={touched} />
            <Button loading={loading} confirmationDialog={confirmationDialog} />
          </Form>
        )}
      </Formik>
    </>
  );
};

export default RegistrationForm;
